/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue"
import axios from "../../http/axios/index.js"

export default {
  SET_CATEGORY_LIST(state, payload) {
    state.categoryList = payload.filter((item) => {
      return item.name != '교과과정 제외'
    })
  },
  SET_MAIN_CATEGORY_LIST(state, payload) {
    state.mainCategoryList = payload
  },
  SET_SUB_CATEGORY_LIST(state, payload) {
    state.subCategoryList = payload
  },
  SET_ACTIVE_GRADE_ID(state, payload) {
    state.activeGradeId = Number(payload)
  },
  SET_ACTIVE_SUBJECT_TYPE_ID(state, payload) {
    if (!payload) {
      state.activeSubjectTypeId = null
      return
    }
    state.activeSubjectTypeId = Number(payload)
  },
  SET_ACTIVE_SUBJECT_DETAIL_TYPE_ID(state, payload) {
    if (!payload) {
      state.activeSubjectDetailTypeId = null
      return
    }
    state.activeSubjectDetailTypeId = Number(payload)
  },
  SET_ACTIVE_CATEGORY(state, payload) {
    state.activeCategory = payload
  },
  SET_ACTIVE_MAIN_CATEGORY(state, payload) {
    state.activeMainCategory = payload
  },
  SET_ACTIVE_SUB_CATEGORY(state, payload) {
    state.activeSubCategory = payload
  },
  SET_ACTIVE_CURRICULUM(state, payload) {
    state.activeCurriculum = payload
  },
  RESET_ACTIVE_CATEGORY(state) {
    state.activeCategory = {}
  },
  RESET_ACTIVE_MAIN_CATEGORY(state) {
    state.activeMainCategory = {}
  },
  RESET_ACTIVE_SUB_CATEGORY(state) {
    state.activeSubCategory = {}
  },
  RESET_MAIN_CATEGORY_LIST(state) {
    state.mainCategoryList = []
  },
  RESET_SUB_CATEGORY_LIST(state) {
    state.subCategoryList = []
  },
  SET_CONCEPT_BOOK_DATA(state, payload) {
    state.conceptBookData = payload
  },
  RESET_CONCEPT_BOOK_DATA(state) {
    state.conceptBookData = {}
  },
  // ===== 목차별 생성 =====
  SET_PUBLISHER_LIST(state, list) {
    state.publisherList = list
  },
  SET_TEXTBOOK_PUBLISHER_LIST(state, list) {
    state.textbookPublisherList = list
  },
  SET_TEXTBOOK_SUBJECT_LIST(state, list) {
    state.textbookSubjectList = list
  },
  SET_ACTIVE_TEXTBOOK(state, payload) {
    state.activeTextbook = payload
  },
  SET_TEXTBOOK_CONTENT_LIST(state, list) {
    state.textbookContentList = list
  },
  SET_TEXTBOOK_CONTENT_MAIN_LIST(state, list) {
    state.textbookContentMainList = list
  },
  SET_TEXTBOOK_CONTENT_SUB_LIST(state, list) {
    state.textbookContentSubList = list
  },
  // 초기화
  RESET_TEXTBOOK_HIERARCHY(state) {
    state.textbookPublisherList = []
    state.textbookSubjectList = []
    state.textbookContentList = []
    state.textbookContentMainList = []
    state.textbookContentSubList = []
  },

}
